var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbeitgeber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-956.000000, -470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/24px/arbeitgeber",
    transform: "translate(956.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21 C21,17.5 17.625,14 12,14 C6.375,14 3,17.5 3,21",
    id: "Path",
    stroke: "#242F38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4672652,14 C13.1380083,14 13.6817529,14.5437446 13.6817529,15.2144877 C13.6817529,15.3207268 13.667813,15.4265066 13.6402902,15.5291187 L13.5069566,16.0262206 C13.3990973,16.4283477 13.1217397,16.7495273 12.7642085,16.9212362 L13.9873592,21.9099726 C14.0264545,22.0693288 13.9785343,22.2374867 13.8613095,22.352296 L13.8613095,22.352296 L12.3086172,23.8729945 C12.1269205,24.0509472 11.8358728,24.0496 11.6558314,23.8699728 L11.6558314,23.8699728 L10.1356269,22.3532652 C10.0198879,22.2377925 9.9734132,22.0699568 10.0132712,21.9113983 L10.0132712,21.9113983 L11.2636523,16.9344962 C10.8924284,16.7663959 10.6031794,16.4389429 10.4924782,16.0262206 L10.3591446,15.5291187 C10.1853787,14.8812749 10.5696947,14.2152286 11.2175385,14.0414627 C11.3201506,14.0139399 11.4259305,14 11.5321696,14 L12.4672652,14 Z",
    id: "Combined-Shape",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#242F38",
    strokeWidth: 2,
    cx: 12,
    cy: 5.5,
    r: 4.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbeitgeber);
export default __webpack_public_path__ + "static/media/arbeitgeber.5e32fdd16daeb67f0047bc73b48d7123.svg";
export { ForwardRef as ReactComponent };